import React, { useState, useContext } from 'react'
import serverData from '../utils/server-data'
import CookieBanner from '../components/common/cookie-banner'
import { getCurrentEnvironment } from '../utils/session-utils'
import logUtil from '../utils/log-util'
import { EXISTING_USER } from '../constants'
const logger = logUtil
// parses FPTI data string from server to object
const parseDataString = (dataString) => {
  const dataStringDecoded = decodeURIComponent(dataString)
  const dataStringParams = new URLSearchParams(dataStringDecoded)
  return Object.fromEntries(dataStringParams)
}

export const ApplicationContext = React.createContext()

const Provider = ({ children }) => {
  // data don't change after page load
  const baseUri = serverData.requestURI || ''
  const sandboxLinkURL = serverData.sandboxLinkURL || ''
  const loginUrl = serverData.loginInfo?.url || '/logmein'
  const logoutUrl = serverData.loginInfo?.logoutUrl || '/logout'
  const elmoData = serverData.elmo || {}
  const cookieBanner = serverData.cookieBannerInfo || {}
  const fptiDataString = serverData.fptiInfo?.dataString || ''
  const fptiData = parseDataString(fptiDataString)
  const banner = serverData.banner
  const deployEnv = serverData.deployEnv
  const servermigration = serverData.servermigration
  const sbrecenttxn = serverData.sbrecenttxn
  const aiSearch = serverData.aiSearch
  const aiSearch_acctID = serverData.aiSearch_acctID
  const feature_flag = serverData.feature_flag
  const isConfirmedEmail = serverData.isConfirmedEmail
  const confirmEmailLink = serverData.confirmEmailLink
  const processedMinAcct = serverData.processedMinAcct
  const secondaryUser = serverData.secondaryUser
  const icPlusCurrencyApi = serverData.icPlusCurrencyApi
  const liveApiAllowed = serverData.liveApiAllowed
  const stepUpNeeded = serverData.stepUpNeeded
  const authflowUrl = serverData.authflowUrl
  const accounttestcards = serverData.accounttestcards
  const [showDeveloperInvite, setShowDeveloperInvite] = useState(
    serverData.showDeveloperInvite,
  )
  const upgradehub_v2 = serverData.upgradehub_v2
  const emailRedirectionPersonal = serverData.emailRedirectionPersonal || ''
  const emailRedirectionBusiness = serverData.emailRedirectionBusiness || ''
  const profileSwitcherUrl = serverData.profileSwitcherUrl || ''
  const profileSwitcherUuid = serverData.profileSwitcherUuid || ''
  const encryptedEmailConfirmtId = serverData.encryptedEmailConfirmtId
  const showSwitchProfile = serverData.showSwitchProfile
  const experimentMetadata = serverData.experimentMetadata || {}
  const createTestAccount = serverData.createTestAccount || EXISTING_USER
  // data could change after page load
  const [user, setUser] = useState(serverData.user)
  const [enviroment, setEnviroment] = useState(
    getCurrentEnvironment(serverData.user),
  )
  const [csrf, setCsrf] = useState(serverData._csrf)
  const [webLLSLogoutUrl, setWebLLSLogoutUrl] = useState(
    serverData.contextualLoginInfo.webllsLogout,
  )
  const [isWebLLSUser, setIsWebLLSUser] = useState(serverData.isWebLLSUser)
  const [fullAuthLoginUrl, setFullAuthLoginUrl] = useState(
    serverData.contextualLoginInfo.contextualFullAuthLoginUrl,
  )
  const [isWebLLSOptedOut, setIsWebLLSOptedOut] = useState(false)
  const [contextualLoginUrl, setContextualLoginUrl] = useState(
    serverData.contextualLoginInfo.contextualLoginUrl,
  )
  const [toggleApps, setToggleApps] = useState(0)
  const [apiDataList, setApiDataList] = useState('')
  const [isAppsDataListLoading, setIsAppsDataListLoading] = useState(false)

  // const [appSwitcherSelection, setAppSwitcherSelection] = useState() // for AppSwitcher
  // const [appSwitcherAccountNumber, setAppSwitcherAccountNumber] = useState() // for AppSwitcher
  // const [appNameSwitcherSelection, setAppNameSwitcherSelection] = useState() // for AppSwitcher
  // const [appSwitcherClientId, setAppSwitcherClientId] = useState() // for AppSwitcher
  // const [appSwitcherClientSecret, setAppSwitcherClientSecret] = useState() // for AppSwitcher

  const [dateRangeSelectorStart, setDateRangeSelectorStart] = useState() // for DateRangeSelector
  const [dateRangeSelectorEnd, setDateRangeSelectorEnd] = useState() // for DateRangeSelector

  const [apiCallData, setApiCallData] = useState() // for FetchApiCalls
  const [apiCallSuccessData, setApiCallSuccessData] = useState() // for FetchApiSuccessCalls
  const [apiWebhooksData, setApiWebhooksData] = useState() // for FetchWebhooks

  const [accountNumber, setAccountNumber] = useState()
  const [clientId, setClientId] = useState()
  const [clientSecret, setClientSecret] = useState()
  const [currentApps, setCurrentApps] = useState() // for app switcher to list all apps.
  const [sandboxApps, setSandboxApps] = useState() // for home app to set sandbox apps
  const [liveApps, setLiveApps] = useState() // for home app to set live apps.
  const [homePageDataLoading, setHomePageDataLoading] = useState() // for home app to set live apps.

  const [currentAppName, setCurrentAppName] = useState() //for app switcher to set the selected app name
  const [currentAppValue, setCurrentAppValue] = useState() //for app switcher to set the selected app value
  const [transactions, setTransactions] = useState() // //for the recent transaction component to render the transactions.
  const [failedTransactions, setFailedTransactions] = useState([]) //for the transaction count component to render the failed transactions.
  const [errorSummaryCount, setErrorSummaryCount] = useState(0) // for the Error count summary (home page)
  const [reloadPage, setReloadPage] = useState() // //for the app checker to set if the app name changed.
  const [isAppsDataLoading, setIsAppsDataLoading] = useState() // //for the app checker to set if the app name changed.
  const [account, setAccount] = useState(null)
  const [card, setCard] = useState(null)
  const [allAccountData, setAllAccountData] = useState(null)
  const [currentLiveApp, setCurrentLiveApp] = useState(null)
  const [currentSandboxApp, setCurrentSandboxApp] = useState(null)
  const [isAppListUpdated, setIsAppListUpdated] = useState(false)

  const [currentBannerStep, setCurrentBannerStep] = useState(null)
  const [userPreferences, setUserPreferences] = useState(null)
  const [nvpSoapAppData, setNvpSoapAppData] = useState(null)
  const [hasApprovalRequest, setHasApprovalRequest] = useState(false)
  const [approvalRequestInfo, setApprovalRequestInfo] = useState([])
  const [sellerInvitationLoaded, setSellerInvitationLoaded] = useState(false)
  const [showSBCreateApp, setShowSBCreateApp] = useState(true)
  const [showLiveCreateApp, setShowLiveCreateApp] = useState(true)

  const [isBannerHidden, setIsBannerHidden] = useState(
    window.sessionStorage.getItem('hideAlert') || false,
  )

  const updateUser = (data = {}) => {
    setUser(data)

    // If the user is logged in, we will have their encrypted account number
    const { encryptedAccountNumber } = data

    // If we have an encrypted account number, and if pa.js (FPTI) has already
    // been loaded, then we can just set the `cust` so that it will be
    // populated for all subsequent FPTI events
    if (encryptedAccountNumber && window && window.fpti) {
      window.fpti.cust = encryptedAccountNumber

      // If pa.js/FPTI has not yet loaded, let's set an event listener, which
      // is set up to be fired when pa.js loads (in dx-analytics.js), and then
      // update the cust property then
    } else if (encryptedAccountNumber) {
      window.addEventListener('paLoaded', async () => {
        window.fpti.cust = encryptedAccountNumber
      })
    }
  }

  const setCurrentEnvironment = (env) => {
    window.localStorage.setItem('environment', env)
    setEnviroment(env)
  }

  return (
    <ApplicationContext.Provider
      value={{
        baseUri,
        sandboxLinkURL,
        loginUrl,
        logoutUrl,
        webLLSLogoutUrl,
        setWebLLSLogoutUrl,
        isWebLLSUser,
        setIsWebLLSUser,
        isWebLLSOptedOut,
        setIsWebLLSOptedOut,
        fullAuthLoginUrl,
        setFullAuthLoginUrl,
        contextualLoginUrl,
        setContextualLoginUrl,
        logger,
        enviroment,
        setCurrentEnvironment,
        user,
        setUser: updateUser,
        elmoData,
        csrf,
        setCsrf,
        fptiData,
        banner,
        deployEnv,
        toggleApps,
        setToggleApps,
        apiDataList,
        setApiDataList,
        isAppsDataListLoading,
        setIsAppsDataListLoading,
        // appSwitcherSelection,
        // setAppSwitcherSelection,
        dateRangeSelectorStart,
        setDateRangeSelectorStart,
        dateRangeSelectorEnd,
        setDateRangeSelectorEnd,
        apiCallData,
        setApiCallData,
        apiCallSuccessData,
        setApiCallSuccessData,
        apiWebhooksData,
        setApiWebhooksData,
        // appSwitcherAccountNumber,
        // setAppSwitcherAccountNumber,
        // appNameSwitcherSelection,
        // setAppNameSwitcherSelection,
        // appSwitcherClientId,
        // setAppSwitcherClientId,
        // appSwitcherClientSecret,
        // setAppSwitcherClientSecret,
        accountNumber,
        clientId,
        clientSecret,
        currentApps,
        sandboxApps,
        liveApps,
        currentAppName,
        currentAppValue,
        transactions,
        reloadPage,
        homePageDataLoading,
        isAppsDataLoading,
        account,
        card,
        allAccountData,
        currentLiveApp,
        currentSandboxApp,
        currentBannerStep,
        failedTransactions,
        userPreferences,
        errorSummaryCount,
        isAppListUpdated,
        nvpSoapAppData,
        setAccountNumber,
        setClientId,
        setClientSecret,
        setCurrentApps,
        setSandboxApps,
        setLiveApps,
        setCurrentAppName,
        setCurrentAppValue,
        setTransactions,
        setReloadPage,
        setHomePageDataLoading,
        setIsAppsDataLoading,
        setAccount,
        setCard,
        setAllAccountData,
        setCurrentLiveApp,
        setCurrentSandboxApp,
        setCurrentBannerStep,
        setFailedTransactions,
        setErrorSummaryCount,
        setUserPreferences,
        setIsAppListUpdated,
        setHasApprovalRequest,
        setApprovalRequestInfo,
        setShowSBCreateApp,
        setShowLiveCreateApp,
        servermigration,
        aiSearch,
        aiSearch_acctID,
        feature_flag,
        isConfirmedEmail,
        confirmEmailLink,
        processedMinAcct,
        isBannerHidden,
        setIsBannerHidden,
        secondaryUser,
        icPlusCurrencyApi,
        setNvpSoapAppData,
        sbrecenttxn,
        liveApiAllowed,
        stepUpNeeded,
        authflowUrl,
        upgradehub_v2,
        emailRedirectionPersonal,
        emailRedirectionBusiness,
        encryptedEmailConfirmtId,
        hasApprovalRequest,
        approvalRequestInfo,
        profileSwitcherUrl,
        profileSwitcherUuid,
        showSwitchProfile,
        sellerInvitationLoaded,
        setSellerInvitationLoaded,
        showDeveloperInvite,
        experimentMetadata,
        setShowDeveloperInvite,
        createTestAccount,
        showSBCreateApp,
        showLiveCreateApp,
        accounttestcards,
      }}
    >
      {children}
      <CookieBanner cookieBannerInfo={cookieBanner} />
    </ApplicationContext.Provider>
  )
}
const ApplicationContextProvider = ({ children }) => (
  <Provider>{children}</Provider>
)

export default ApplicationContextProvider

export const useApplicationContext = () => useContext(ApplicationContext)
